import React from 'react';
import {
  LineChart,
  Line,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from 'recharts';

interface VisibilityChartProps {
  className?: string;
}

const LINES = [
  { key: 'tradingbase', label: 'TradingBase', color: '#7c3aed' },
  { key: 'commas',      label: '3Commas',     color: '#0ea5e9' },
  { key: 'pionex',      label: 'Pionex',      color: '#10b981' },
  { key: 'hopper',      label: 'Cryptohopper',color: '#f59e0b' },
  { key: 'bitsgap',     label: 'Bitsgap',     color: '#f43f5e' },
];

const chartData = [
  { date: '5/26', tradingbase: 28, commas: 58, pionex: 47, hopper: 22, bitsgap: 14 },
  { date: '5/27', tradingbase: 31, commas: 61, pionex: 50, hopper: 24, bitsgap: 15 },
  { date: '5/28', tradingbase: 34, commas: 63, pionex: 52, hopper: 25, bitsgap: 16 },
  { date: '5/29', tradingbase: 36, commas: 65, pionex: 54, hopper: 27, bitsgap: 17 },
  { date: '5/30', tradingbase: 39, commas: 67, pionex: 55, hopper: 28, bitsgap: 18 },
  { date: '5/31', tradingbase: 41, commas: 69, pionex: 57, hopper: 30, bitsgap: 19 },
  { date: '6/1',  tradingbase: 44, commas: 71, pionex: 58, hopper: 32, bitsgap: 21 },
];

const CustomLegend = () => (
  <div className="flex flex-wrap gap-x-4 gap-y-1 px-1 pt-2 pb-1">
    {LINES.map((l) => (
      <div key={l.key} className="flex items-center gap-1.5">
        <span className="inline-block w-3 h-0.5 rounded-full" style={{ backgroundColor: l.color }} />
        <span className="text-[11px] text-slate-500">{l.label}</span>
      </div>
    ))}
  </div>
);

export const VisibilityChart: React.FC<VisibilityChartProps> = ({ className = '' }) => {
  return (
    <div className={`flex flex-col h-full w-full min-h-0 ${className}`}>
      <CustomLegend />
      <div className="flex-1 min-h-0">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData} margin={{ top: 6, right: 12, left: -12, bottom: 0 }}>
            <CartesianGrid stroke="#f1f5f9" strokeDasharray="4 4" vertical={false} />
            <XAxis
              dataKey="date"
              tickLine={false}
              axisLine={{ stroke: '#e2e8f0' }}
              tick={{ fill: '#94a3b8', fontSize: 11 }}
            />
            <YAxis
              tickLine={false}
              axisLine={false}
              width={28}
              tick={{ fill: '#94a3b8', fontSize: 11 }}
              domain={[0, 80]}
            />
            <Tooltip
              cursor={{ stroke: '#e2e8f0', strokeDasharray: '4 4' }}
              contentStyle={{
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: 8,
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.06)',
                fontSize: 12,
              }}
              labelStyle={{ color: '#64748b', fontSize: 11, marginBottom: 4 }}
              formatter={(value: number, name: string) => {
                const line = LINES.find(l => l.key === name);
                return [`${value}%`, line?.label ?? name];
              }}
            />
            {LINES.map((l) => (
              <Line
                key={l.key}
                type="monotone"
                dataKey={l.key}
                stroke={l.color}
                strokeWidth={2}
                dot={false}
                activeDot={{ r: 4, fill: l.color, stroke: '#fff', strokeWidth: 2 }}
                isAnimationActive={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
